import React from "react";
import { motion } from "framer-motion";

const variants = {
  hidden: { opacity: 0, scale: 0.6, pointerEvents: "none" },
  visible: { opacity: 1, scale: 1, pointerEvents: "auto" },
};

// Floating "report" shortcut, shown once the user has scrolled past the hero.
const ReportFab = ({ visible, onClick }) => (
  <div className="bleep-fab-wrap">
    <motion.div
      variants={variants}
      initial="hidden"
      animate={visible ? "visible" : "hidden"}
      transition={{ duration: 0.18 }}
    >
      {/* The label is always in the DOM, only collapsed to zero width, so it
          names the button for screen readers even while it reads as an icon.
          That is also why there is no aria-label: an override would leave the
          accessible name different from the visible one. */}
      <button
        type="button"
        className="bleep-fab"
        onClick={onClick}
        title="Report a counterfeit"
      >
        <span className="bleep-fab__icon">
          <i className="fa-solid fa-bolt-lightning" />
        </span>
        <span className="bleep-fab__label">
          <span>Report Now</span>
        </span>
      </button>
    </motion.div>
  </div>
);

export default ReportFab;
